module.exports = __webpack_public_path__ + "img/platina.65ba2c8a.png";